export default function MouvementStockConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('mouvement.stock');
}

MouvementStockConfiguration.$inject = ['$translatePartialLoaderProvider'];
